import { USER_LOGOUT_SUCCESS } from "../../ActionType/loginTypes";
import {
  FETCH_ATTENDANCE_FAIL,
  FETCH_ATTENDANCE_REQUEST,
  FETCH_ATTENDANCE_SUCCESS,
  SHOW_ATTENDANCE_FAIL,
  SHOW_ATTENDANCE_REQUEST,
  SHOW_ATTENDANCE_SUCCESS,
  UPDATE_ATTENDANCE_FAIL,
  UPDATE_ATTENDANCE_REQUEST,
  UPDATE_ATTENDANCE_SUCCESS,
} from "../../ActionType/UserType/AttendanceType";
import { api } from "../../Api/api";
import { getToken } from "../login";
import swal from "sweetalert";

export const getAttendanceAction =
  (perPage, page, from, to) => async (dispatch) => {
    const config = {
      headers: {
        Authorization: `Bearer ${getToken()}`,
      },
      params: {
        page,
        perPage,
        from,
        to,
      },
    };

    dispatch({
      type: FETCH_ATTENDANCE_REQUEST,
      payload: [],
    });
    try {
      const response = await api.get("attendance", config);
      const { status, data } = response;
      // console.log(data.data);
      if (status == 200) {
        dispatch({
          type: FETCH_ATTENDANCE_SUCCESS,
          payload: { data: data.data, total: data.total },
        });
      }
    } catch (error) {
      if (error.response.status == 401) {
        dispatch({ type: USER_LOGOUT_SUCCESS });
        localStorage.removeItem("token");
      }
      dispatch({
        type: FETCH_ATTENDANCE_FAIL,
        payload: [],
      });
    }
  };

export const showAttendanceAction =
  (page, perPage, userId, from, to) => async (dispatch) => {
    const config = {
      headers: {
        Authorization: `Bearer ${getToken()}`,
      },
      params: {
        page,
        perPage,
        from,
        to,
      },
    };

    dispatch({
      type: SHOW_ATTENDANCE_REQUEST,
      payload: [],
    });
    try {
      const response = await api.get("attendance/show/" + userId, config);
      const { status, data } = response;
      // console.log("REXS : ",response);
      if (status == 200) {
        dispatch({
          type: SHOW_ATTENDANCE_SUCCESS,
          payload: { data: data.data, total: data.total },
        });
      }
    } catch (error) {
      if (error.response.status == 401) {
        dispatch({ type: USER_LOGOUT_SUCCESS });
        localStorage.removeItem("token");
      }
      dispatch({
        type: SHOW_ATTENDANCE_FAIL,
        payload: [],
      });
    }
  };


  export const deleteAttendanceAction =
  (id) => async (dispatch) => {
    const config = {
      headers: {
        Authorization: `Bearer ${getToken()}`,
      },
  
    };


    try {
      const response = await api.delete("attendance/delete/" + id, config);
      const { status, data } = response;
    
      if (status == 200) {
        
        swal({
          title: "Good job!",
          text: "Attendance was delete Successfully !",
          icon: "success",
          button: "OK",
          timer: 2000,
        });
      }
    } catch (error) {
      if (error.response.status == 401) {
        dispatch({ type: USER_LOGOUT_SUCCESS });
        localStorage.removeItem("token");
      }
      dispatch({
        type: SHOW_ATTENDANCE_FAIL,
        payload: [],
      });
    }
  };

export const updateAttendanceAction =
  (id, type, time, userId) => async (dispatch) => {
    const config = {
      headers: {
        Authorization: `Bearer ${getToken()}`,
      },
    };
    dispatch({
      type: UPDATE_ATTENDANCE_REQUEST,
      payload: [],
    });
    try {
      const response = await api.patch(
        "attendance/update/" + id,
        { type, time },
        config
      );
      const { status, data } = response;
      // console.log(response)
      if (status == 200) {
        dispatch(getAttendanceAction(50, 0, "", ""));
        dispatch(getAttendanceAction(50, 0, "", ""));
        if (userId) {
          dispatch(showAttendanceAction(0, 50, userId, "", ""));
          dispatch(showAttendanceAction(0, 50, userId, "", ""));
        }

        swal({
          title: "Good job!",
          text: "Attendance was update Successfully !",
          icon: "success",
          button: "OK",
          timer: 2000,
        });

        dispatch({
          type: UPDATE_ATTENDANCE_SUCCESS,
          payload: data,
        });
      }
    } catch (error) {
      if (error.response.status == 401) {
        dispatch({ type: USER_LOGOUT_SUCCESS });
        localStorage.removeItem("token");
      }
      dispatch({
        type: UPDATE_ATTENDANCE_FAIL,
        payload: [],
      });
    }
  };
